import { type PrayerStreamNamespace } from '../en-US/prayerStream';

export const prayerStream = {
  channel_group_community_groups: 'Grupos Comunitarios',
  channel_group_member_prayer: 'Oración de los Miembros',
  channel_name_formatted: '# {{name}}',
  disclaimer: 'Las oraciones y los detalles personales compartidos aquí permanecerán visibles para los miembros actuales y futuros, así que comparta solo aquello con lo que se sienta cómodo que siga siendo parte de esta comunidad.',
  empty_channel_primary_description: 'Este es el comienzo de tu historial de chat en #{{name}}',
  empty_channel_secondary_description: 'Envía mensajes, archivos adjuntos, enlaces, emojis y más',
  go_to_member_center: 'Ir al Centro de Miembros',
  join_group: 'Unirse al Grupo',
  members_online_one: '{{count}} Member en Línea',
  members_online_other: '{{count}} Members en Línea',
  no_community_groups_header: 'No te has unido a ningún Grupo de la Comunidad',
  no_community_groups_subtext: 'Visita la configuración para explorar y unirte a grupos.',
  no_share_events_header: 'No tienes Eventos para Compartir',
  prayer_stream: 'PrayerStream',
  reaction_like_emoji: '👍',
  reaction_like_name: 'Gusta',
  reaction_love_emoji: '❤️',
  reaction_love_name: 'Encanta',
  reaction_pray_emoji: '🙏',
  reaction_pray_name: 'Rezo',
  reaction_sad_emoji: '😔',
  reaction_sad_name: 'Triste',
  reaction_wow_emoji: '😲',
  reaction_wow_name: 'Sorprendido',
  replies_one: '{{count}} respuesta',
  replies_other: '{{count}} respuestas',
  send_a_message: 'Send a message',
  share_events: 'Compartir Eventos',
  thread: 'Hilo',
} as const satisfies PrayerStreamNamespace;
